import type { RouteMeta } from 'vue-router';
import { ability } from '@boqnet/permissions';

/**
 * Single source of truth for the CASL route-permission check.
 *
 * Returns `true` when the given route meta requires a permission the current ability lacks.
 * An `anyOf` list (satisfy at least one) takes precedence over the single `action`/`subject`
 * pair, mirroring the route guard's meta contract.
 *
 * Used by the router `beforeEach` guard (`router/index.ts`), the `App.vue` post-flag re-check,
 * and `revalidateRouteAfterRoleChange` (`pusher.utils.ts`) so all three stay in lockstep — do
 * not re-inline this check at a call site.
 */
export const isRouteBlockedByAbility = (meta: RouteMeta): boolean => {
  const { action, subject, anyOf } = meta;

  return anyOf
    ? !anyOf.some((p) => ability.can(p.action, p.subject))
    : Boolean(action && subject && !ability.can(action, subject));
};
